<template xmlns="http://www.w3.org/1999/html">
  <div class="worklogs-planning-cel">
    <div v-if="!plannedHoursByProject">
      <input v-if="showWorkloadPlanner" type="text" size="1" :disabled="timeframe != 'week'" class="work-load-planner"
        @input="updatePlannedWorkload(plannedHours)" v-model.number="plannedHours"
        onClick="this.setSelectionRange(0, this.value.length)">
      <span v-if="showTotalPlanned && showHours" class="total-user-planned-hours-number"
        :class="{ 'zero-value': !totalPlanned.totalPlanned && !totalPlanned.totalCalculated, 'project-tooltip': totalPlanned.projects }">
        <template v-if="dateIndex === actualDate">
          {{ numberWithSpaces(((totalPlanned.plannedTimeFromTodayTillPeriodEnd / 3600).toFixed(2))) }}
        </template>
        <template v-else>
          {{ numberWithSpaces(((totalPlanned.totalPlanned + totalPlanned.totalCalculated) / 3600).toFixed(2)) }}
        </template>
        <!--<span class="tooltiptext" v-if="totalPlanned.projects">-->
        <!--<div v-for="(planned, projectId) in totalPlanned.projects">{{projects[projectId].name}}: {{(planned.plannedTime/3600).toFixed(2)}} + {{(planned.calculatedTime/3600).toFixed(2)}}</div>-->
        <!--</span>-->
      </span>
      <span v-if="showTotalPlanned && showRateTime" class="currency expenses-number"
        :class="{ 'zero-value': !totalPlanned.totalExpenses, 'project-tooltip': totalPlanned.projects }">
        {{ numberWithSpaces(((totalPlanned.totalExpenses) / 3600).toFixed(2)) }}
        <!--<span class="tooltiptext" v-if="totalPlanned.projects">-->
        <!--<div v-for="(planned, projectId) in totalPlanned.projects">{{projects[projectId].name}}: {{(planned.plannedTime/3600).toFixed(2)}} + {{(planned.calculatedTime/3600).toFixed(2)}}</div>-->
        <!--</span>-->
      </span>
    </div>
    <div v-if="plannedHoursByProject">
      <div v-if="totalPlanned.projects" v-for="(project, index) in totalPlanned.projects">
        <template v-if="projectId == index && showHours ? indexFound = true : ''">
          <template v-if="dateIndex === actualDate">
            {{ numberWithSpaces(((totalPlanned.projects[index].plannedTimeFromTodayTillPeriodEnd / 3600).toFixed(2))) }}
          </template>
          <template v-else>
            {{ numberWithSpaces(((totalPlanned.projects[index].calculatedTime +
                totalPlanned.projects[index].plannedTime) / 3600).toFixed(2))
            }}
          </template>
        </template>
        <span class="currency" v-if="projectId == index && showRateTime ? indexFound = true : ''">{{
            numberWithSpaces(((totalPlanned.projects[index].expenses) / 3600).toFixed(2))
        }}</span>
      </div>
      <div v-if="!indexFound">
        <span class="zero-value" :class="[showHours ? '' : 'currency']">0.00</span>
      </div>
      <!--<span v-if="projectId == index">{{Math.round((totalPlanned.projects[index].calculatedTime + totalPlanned.projects[index].plannedTime)/3600).toFixed(0)}}</span>-->
      <!--<span v-if="totalPlanned.projects[projectId]">{{Math.round((totalPlanned.projects[projectId].calculatedTime + totalPlanned.projects[projectId].plannedTime)/3600).toFixed(0)}}</span>-->
      <!--<span v-else>0</span>-->
    </div>
    <!--<div :class="{'align-left': dateIndex > actualDate}" v-if="projectPlanning">-->
    <!--<input v-if="showWorkloadPlanner && dateIndex > actualDate && (plannedHours >= 0 && calculatedHours == 0)" type="text" size="1" :disabled="timeframe!='week' || dateIndex < actualDate" class="work-load-planner" @input="updatePlannedWorkload(plannedHours)" v-model.number="plannedHours" onClick="this.setSelectionRange(0, this.value.length)">-->
    <!--<input v-if="showWorkloadPlanner && dateIndex > actualDate && (calculatedHours > 0)" type="text" size="1" class="work-load-planner" v-model.number="totalPlannedHours" disabled>-->
    <!--&lt;!&ndash;<span :class="{'zero-value': !totalPlanned.totalPlanned && !totalPlanned.totalCalculated, 'project-tooltip': totalPlanned.projects}" v-if="showTotalPlanned && ((totalPlanned.totalPlanned + totalPlanned.totalCalculated) != 0)">&ndash;&gt;-->
    <!--&lt;!&ndash;<div v-for="(planned, index) in totalPlanned.projects">&ndash;&gt;-->
    <!--&lt;!&ndash;<span v-if="index == projectId" class="planned-number">{{Math.round((totalPlanned.projects[projectId].plannedTime + totalPlanned.projects[projectId].calculatedTime) / 3600)}}</span>&ndash;&gt;-->
    <!--&lt;!&ndash;<span class="tooltiptext" v-if="totalPlanned.projects">&ndash;&gt;-->
    <!--&lt;!&ndash;<div>&ndash;&gt;-->
    <!--&lt;!&ndash;<small v-if="index == projectId">Project name: Planned hours + calculated hours <br></small>&ndash;&gt;-->
    <!--&lt;!&ndash;<small v-if="index == projectId">{{projects[index].name}}: {{(totalPlanned.projects[projectId].plannedTime/3600).toFixed(0)}} + {{(totalPlanned.projects[projectId].calculatedTime/3600).toFixed(0)}} </small>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</span>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--&lt;!&ndash;</span>&ndash;&gt;-->
    <!--</div>-->
    <!--<div :class="{'align-left': dateIndex > actualDate}" v-if="projectPlanning && dateIndex > actualDate">-->
    <!--<span :class="{'zero-value': !totalPlanned.totalPlanned && !totalPlanned.totalCalculated, 'total-user-planned-hours-number': totalPlanned.totalPlanned || totalPlanned.totalCalculated, 'project-tooltip': totalPlanned.projects}" v-if="showTotalPlanned && (totalPlanned.totalPlanned || totalPlanned.totalCalculated)">-->
    <!--{{Math.round((totalPlanned.totalPlanned + totalPlanned.totalCalculated) / 3600)}}-->
    <!--<span class="tooltiptext" v-if="totalPlanned.projects">-->
    <!--<div v-for="(planned, projectId) in totalPlanned.projects"><small>{{projects[projectId].name}}: {{(planned.plannedTime/3600).toFixed(0)}} + {{(planned.calculatedTime/3600).toFixed(0)}}</small></div>-->
    <!--</span>-->
    <!--</span>-->
    <!--</div>-->
    <!--<div :class="{'zero-value': (!plannedHours && !totalPlanned.totalCalculated) || !ratesOnDate(datesByYearweek[dateIndex], userId)}" class="currency">{{((plannedHours + (totalPlanned.totalCalculated/3600)) * ratesOnDate(datesByYearweek[dateIndex], userId)).toFixed(0)}}</div>-->
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
// import Templates from '../documents/Templates';

export default {
  name: 'WorkloadPlanningCell',
  props: [
    'userId',
    'totalPlanned',
    'projectId',
    'dateIndex',
    'showPlannedExpenses',
    'showWorkloadPlanner',
    'showTotalPlanned',
    'timeframe',
    'plannedHoursByProject',
    'showHours',
    'showRateTime'
  ],
  data: function () {
    return {
      plannedHours: 0,
      calculatedHours: 0,
      //                totalPlanned: {
      //                    totalPlanned: 0,
      //                    totalCalculated: 0,
      //                    totalExpenses: 0,
      //                    projects: null
      //                },
      indexFound: false,
    };
  },
  watch: {
    //            dateIndex: function(){ this.setInitialHours(); },
    //            timeframe: function(){ this.setInitialHours(); },
  },
  components: {
    // Templates
  },
  computed: {
    //            ...mapGetters('WorkloadPlans', [
    //                'workloadsByProjectByUserByYearweek',
    //                'workloads',
    //                'workloadsByUserByYearweekByProject',
    //                'workloadsByUserByMonthByProject',
    //                'workloadsByUserByQuarterByProject',
    //                'workloadsByUserByYearByProject',
    //            ]),
    ...mapGetters('Worklogs', [
      // 'datesByYearweek', 'weekOffset', 'weekCount',
      'actualDateDay', 'actualDate'
    ]),
    //            ...mapGetters('UserRates', [
    //                'ratesOnDate',
    //            ]),
    //            ...mapGetters('JiraProjects', [
    //                'projects',
    //            ]),
  },
  methods: {
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    //            ...mapActions('WorkloadPlans', [
    //                'UPDATE_PLANNED_WORKLOAD', 'LOAD_PLANNED_WORKLOADS'
    //            ]),
    //            calculateTotalPlanned(){
    //                var plannedWorkloads;
    //                switch(this.timeframe){
    //                    case 'week':
    //                        plannedWorkloads = this.workloadsByUserByYearweekByProject;
    //                        break;
    //                    case 'month':
    //                        plannedWorkloads = this.workloadsByUserByMonthByProject;
    //                        break;
    //                    case 'quarter':
    //                        plannedWorkloads = this.workloadsByUserByQuarterByProject;
    //                        break;
    //                    case 'year':
    //                        plannedWorkloads = this.workloadsByUserByYearByProject;
    //                        break;
    //                }
    //                console.log('plannedWorkloads', plannedWorkloads);
    //                if(plannedWorkloads[this.userId] && plannedWorkloads[this.userId][this.dateIndex]){
    //                    this.totalPlanned = plannedWorkloads[this.userId][this.dateIndex];
    /// /                    console.log(this.userId, this.totalPlanned);
    //                }else {
    //                    this.totalPlanned = {
    //                        totalPlanned: 0,
    //                        totalCalculated: 0,
    //                        totalExpenses: 0,
    //                        projects: null
    //                    };
    //                }
    //            },
    //            updatePlannedWorkload(plannedHours){
    //                this.UPDATE_PLANNED_WORKLOAD({plannedSeconds: plannedHours * 3600, user_id: this.userId, project_id: this.projectId, date: this.dateIndex, uid: this._uid});
    //            },
    //            setInitialHours(){
    //                if(this.totalPlanned.projects && this.totalPlanned.projects[this.projectId]){
    //                    this.plannedHours = parseInt(this.totalPlanned.projects[this.projectId].plannedTime)/3600;
    //                    this.calculatedHours = parseInt(this.totalPlanned.projects[this.projectId].calculatedTime)/3600;
    //                    this.totalPlannedHours = this.plannedHours + this.calculatedHours;
    //                }else{
    //                    this.plannedHours = 0;
    //                }
    //            }
  },
  mounted() {
    // const _this = this;
    //            _this.calculateTotalPlanned();
    //            _this.setInitialHours();
    //            this.LOAD_PLANNED_WORKLOADS(function(workloads){
    //                console.log('testata');
    //                _this.calculateTotalPlanned();
    /// /                _this.setInitialHours();
    //            });
    //            EventBus.$on('update-planned-workload-' + this._uid, function(data) {
    //                _this.calculateTotalPlanned();
    //            });
  },
};
</script>
<style scoped>
.align-left {
  text-align: left;
  padding-left: 5px;
}

.planned-number {
  font-weight: bold;
  color: #005ef7;
  color: blueviolet;
}

.total-user-planned-hours-number {
  color: blueviolet;
}

.work-load-planner {
  line-height: normal;
}

.currency::after {
  content: " €";
}

/**/
/*.project-tooltip {*/
/*position: relative;*/
/*display: inline-block;*/
/*border-bottom: 1px dotted black;*/
/*}*/

/*.project-tooltip .tooltiptext {*/
/*visibility: hidden;*/
/*width: 400px;*/
/*background-color: black;*/
/*color: #fff;*/
/*text-align: center;*/
/*border-radius: 6px;*/
/*padding: 5px 0;*/

/*!* Position the tooltip *!*/
/*position: absolute;*/
/*z-index: 1;*/
/*!*top: 100%;*!*/
/*left: 50%;*/
/*bottom:50%;*/
/*margin-left: -125px;*/
/*}*/

/*.project-tooltip:hover .tooltiptext {*/
/*visibility: visible;*/
/*}*/
.zero-value {
  color: silver;
}

.expenses-number {
  color: darkgreen;
}
</style>
